import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';

interface Status {
  id: number;
  name: string;
}

interface Substatus {
  id: number;
  name: string;
  statusId: number;
  status: Status;
}

const fetchStatusOptions = async (): Promise<Status[]> => {
  try {
    const { data } = await api.get<Status[]>('/api/statuses');
    return data;
  } catch (error) {
    throw new Error('Error al obtener los estados');
  }
};

const fetchSubstatusOptions = async (): Promise<Substatus[]> => {
  try {
    const { data } = await api.get<Substatus[]>('/api/statuses/substatuses');
    return data;
  } catch (error) {
    throw new Error('Error al obtener los subestados');
  }
};

export const useStatusOptions = (selectedStatusId?: number) => {
  const { data: statusOptions = [] } = useQuery({
    queryKey: ['statusOptions'],
    queryFn: fetchStatusOptions,
  });

  const { data: allSubstatusOptions = [] } = useQuery({
    queryKey: ['substatusOptions'],
    queryFn: fetchSubstatusOptions,
  });

  const filteredSubstatusOptions = selectedStatusId 
    ? allSubstatusOptions.filter(
        (substatus) => substatus.statusId === selectedStatusId
      )
    : [];

  return {
    statusOptions,
    substatusOptions: filteredSubstatusOptions,
    allSubstatusOptions,
  };
}; 